import React from 'react';

/**
 * UserGuidingPingProvider - placeholder component for potential real-time UserGuiding updates
 * 
 * Currently the admin panel doesn't have the userGuidingUserPayloadPublished websocket event,
 * so this component is a no-op. If real-time UserGuiding updates are needed in the future,
 * the event listener can be added here similar to the customer frontend implementation.
 */
export const UserGuidingPingProvider: React.FC = () => {
  return null;
};
